import { render, staticRenderFns } from "./PlanejamentoAcaoFormOrigemAcao.vue?vue&type=template&id=79149897"
import script from "./PlanejamentoAcaoFormOrigemAcao.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoFormOrigemAcao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports